export const translations = {
  en: {
    nav: {
      home: "Home",
      courses: "Golf Courses",
      offers: "Partner Offers",
      contact: "Contact",
      book: "Book Now"
    },
    hero: {
      subtitle: "Established in 2003 as Mallorca's first golf agency. Leaders in innovation with the island's first 24/7 real-time booking system service.",
      title: "Play the Best Golf Courses in Mallorca",
      description: "Leaders in innovation with the island's first 24/7 real-time booking system. Book tee times, golf holiday packages, and luxury stay & play deals at 19 premium courses.",
      bookTeeTime: "Book a tee time now",
      cta: "Start Your Journey",
      ctaSecondary: "View golf courses in Mallorca"
    },
    about: {
      subtitle: "Your Golf Concierge",
      title: "The Leading Golf Agency in Mallorca",
      description: "Since 2003, we are the only exclusive golf operator based on the island. From booking tee times and arranging golf holiday packages to recommending luxury resorts and fine dining, we handle every detail of your Mallorca golf trip.",
      point1: "19 championship golf courses across Mallorca & the Balearic Islands",
      point2: "Luxury golf hotel packages & stay and play deals",
      point3: "Personalized golf concierge service in your language"
    },
    courses: {
      subtitle: "Golf Courses in Mallorca",
      title: "Book Tee Times at 19 Premium Courses",
      description: "From championship layouts to scenic coastal courses, explore the best golf courses in Mallorca, Ibiza & Menorca with instant tee time confirmation.",
      holes: "Holes",
      par: "Par",
      from: "From",
      bookNow: "Book Tee Time"
    },
    offers: {
      subtitle: "Partner Offers",
      title: "Exclusive Deals for You",
      hotels: "Luxury Hotels",
      restaurants: "Fine Dining",
      from: "From",
      save: "Save",
      viewDeal: "View Deal",
      bookHotel: "Book Now",
      exclusive: "Exclusive Offer",
      viewDetails: "View Details",
      bookNow: "Book Now"
    },
    card: {
      hoverForDetails: "Tap for details"
    },
    hotels: {
      subtitle: "Golf Resorts & Hotels",
      title: "Luxury Golf Hotels in Mallorca",
      description: "Stay and play at Mallorca's finest golf resorts and luxury hotels. Exclusive golf holiday packages with special rates for our clients."
    },
    restaurants: {
      subtitle: "Restaurants & Bars",
      title: "Fine Dining After Your Round",
      description: "Discover exceptional Mediterranean cuisine at our partner restaurants, from Michelin-starred dining to authentic Mallorcan cuisine.",
      reserve: "Reserve Table"
    },
    beachClubs: {
      subtitle: "Relax After Golf",
      title: "Mallorca's Best Beach Clubs",
      description: "Unwind after your round at Mallorca's most exclusive beach clubs with pools, sea views, and special golfer packages."
    },
    cafeBars: {
      subtitle: "The 19th Hole",
      title: "Bars, Cafés & Brunch Spots",
      description: "From the perfect morning espresso to sunset cocktails, discover the best cafés and bars near Mallorca's golf courses."
    },
    contact: {
      subtitle: "Plan Your Golf Trip",
      title: "Book Your Mallorca Golf Holiday",
      description: "Tell us about your golf trip and our concierge team will craft a personalised package — tee times, hotels, transfers, and dining — within 24 hours.",
      name: "Your Name",
      email: "Email Address",
      phone: "Phone Number",
      country: "Your Country",
      message: "Tell us about your golf plans",
      send: "Send Inquiry",
      success: "Thank you! We'll be in touch soon.",
      countries: {
        germany: "Germany",
        sweden: "Sweden",
        switzerland: "Switzerland",
        uk: "United Kingdom",
        france: "France",
        other: "Other"
      }
    },
    footer: {
      tagline: "The leading golf agency in Mallorca since 2003. Book tee times, golf holidays & packages.",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      followUs: "Follow Us",
      rights: "All rights reserved."
    },
    blog: {
      subtitle: "Mallorca Golf Guide",
      title: "Tips, Course Guides & Travel Advice",
      description: "Expert golf travel tips, detailed course guides, and insider advice for planning your perfect Mallorca golf holiday.",
      readMore: "Read More",
      categories: {
        travelTips: "Travel Tips",
        courseGuides: "Course Guides",
        lifestyle: "Lifestyle"
      }
    },
    reviews: {
      subtitle: "Client Reviews",
      title: "What Our Golfers Say",
      reviewsCount: "reviews",
      loadMore: "Load More Reviews",
      leaveReview: "Share Your Experience",
      yourRating: "Your Rating",
      yourName: "Your Name",
      yourCountry: "Your Country",
      coursePlayed: "Course Played (optional)",
      reviewTitle: "Review Title",
      yourReview: "Tell us about your experience...",
      submit: "Submit Review",
      submitSuccess: "Thank you! Your review will appear after approval.",
      moderationNote: "Reviews are moderated before publishing.",
      shareExperience: "Played in Mallorca?",
      shareDescription: "Help other golfers by sharing your experience with our courses and services.",
      writeReview: "Write a Review"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      courses: "Golfplätze",
      offers: "Partnerangebote",
      contact: "Kontakt",
      book: "Jetzt Buchen"
    },
    hero: {
      subtitle: "Exklusive Golf-Erlebnisse",
      title: "Entdecken Sie Mallorcas Besten Golf",
      description: "Ihr Tor zu Premium-Golfplätzen, Luxusunterkünften und unvergesslichen mediterranen Erlebnissen.",
      bookTeeTime: "Jetzt Tee Time buchen",
      cta: "Starten Sie Ihre Reise",
      ctaSecondary: "Golfplätze auf Mallorca ansehen"
    },
    about: {
      subtitle: "Über Uns",
      title: "Ihr Premier Golf-Concierge auf Mallorca",
      description: "Die führende Golfargentur auf Mallorca seit 2003. Als einziger exklusiver Betreiber mit Sitz auf der Insel sind wir auf alle Arten von Golfdienstleistungen spezialisiert.",
      point1: "Kuratierte Auswahl an Championship-Plätzen",
      point2: "Exklusive Hotel- & Restaurant-Partnerschaften",
      point3: "Persönlicher Service in Ihrer Sprache"
    },
    courses: {
      subtitle: "Golfplätze",
      title: "Weltklasse-Plätze Erwarten Sie",
      description: "Buchen Sie Abschlagzeiten auf 19 Premium-Golfplätzen auf Mallorca, Ibiza & Menorca mit sofortiger Bestätigung.",
      holes: "Löcher",
      par: "Par",
      from: "Ab",
      bookNow: "Abschlagzeit Buchen"
    },
    offers: {
      subtitle: "Partnerangebote",
      title: "Exklusive Angebote für Sie",
      hotels: "Luxushotels",
      restaurants: "Fine Dining",
      from: "Ab",
      save: "Sparen Sie",
      viewDeal: "Angebot Ansehen",
      bookHotel: "Jetzt Buchen",
      exclusive: "Exklusives Angebot",
      viewDetails: "Details Ansehen",
      bookNow: "Jetzt Buchen"
    },
    card: {
      hoverForDetails: "Tippen für Details"
    },
    hotels: {
      subtitle: "Hotel Partner",
      title: "Luxusunterkünfte",
      description: "Übernachten Sie in Mallorcas besten Hotels mit exklusiven Golf-Paketen und Sonderpreisen für unsere Kunden."
    },
    restaurants: {
      subtitle: "Restaurants & Bars",
      title: "Kulinarische Erlebnisse",
      description: "Entdecken Sie außergewöhnliche mediterrane Küche in unseren Partner-Restaurants mit exklusiven Angeboten.",
      reserve: "Tisch Reservieren"
    },
    beachClubs: {
      subtitle: "Entspannen Nach Dem Golf",
      title: "Premium Beach Clubs",
      description: "Entspannen Sie nach Ihrer Runde in Mallorcas exklusivsten Beach Clubs mit speziellen Golfer-Paketen."
    },
    cafeBars: {
      subtitle: "Kaffee, Cocktails & Brunch",
      title: "Bars, Cafés & Brunch",
      description: "Vom perfekten Morgen-Espresso bis zum Sonnenuntergangs-Cocktail – entdecken Sie Mallorcas beste Orte für Kaffeeliebhaber."
    },
    contact: {
      subtitle: "Kontaktieren Sie Uns",
      title: "Planen Sie Ihren Golf-Urlaub",
      description: "Füllen Sie das Formular aus und unser Team wird Sie innerhalb von 24 Stunden kontaktieren, um Ihr perfektes Mallorca-Golf-Erlebnis zu gestalten.",
      name: "Ihr Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      country: "Ihr Land",
      message: "Erzählen Sie uns von Ihren Golfplänen",
      send: "Anfrage Senden",
      success: "Vielen Dank! Wir melden uns bald bei Ihnen.",
      countries: {
        germany: "Deutschland",
        sweden: "Schweden",
        switzerland: "Schweiz",
        uk: "Vereinigtes Königreich",
        france: "Frankreich",
        other: "Andere"
      }
    },
    footer: {
      tagline: "Die führende Golfargentur auf Mallorca seit 2003",
      quickLinks: "Schnelllinks",
      contactInfo: "Kontaktinfo",
      followUs: "Folgen Sie Uns",
      rights: "Alle Rechte vorbehalten."
    },
    blog: {
      subtitle: "Golf Blog",
      title: "Tipps & Einblicke",
      description: "Expertenrat, Platzführer und Insidertipps für Ihr Mallorca-Golferlebnis.",
      readMore: "Weiterlesen",
      categories: {
        travelTips: "Reisetipps",
        courseGuides: "Platzführer",
        lifestyle: "Lifestyle"
      }
    },
    reviews: {
      subtitle: "Kundenbewertungen",
      title: "Was Unsere Golfer Sagen",
      reviewsCount: "Bewertungen",
      loadMore: "Mehr Bewertungen Laden",
      leaveReview: "Teilen Sie Ihre Erfahrung",
      yourRating: "Ihre Bewertung",
      yourName: "Ihr Name",
      yourCountry: "Ihr Land",
      coursePlayed: "Gespielter Platz (optional)",
      reviewTitle: "Bewertungstitel",
      yourReview: "Erzählen Sie uns von Ihrer Erfahrung...",
      submit: "Bewertung Absenden",
      submitSuccess: "Vielen Dank! Ihre Bewertung erscheint nach Genehmigung.",
      moderationNote: "Bewertungen werden vor der Veröffentlichung moderiert.",
      shareExperience: "Auf Mallorca gespielt?",
      shareDescription: "Helfen Sie anderen Golfern, indem Sie Ihre Erfahrungen teilen.",
      writeReview: "Bewertung Schreiben"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      courses: "Parcours de Golf",
      offers: "Offres Partenaires",
      contact: "Contact",
      book: "Réserver"
    },
    hero: {
      subtitle: "Expériences Golf Exclusives",
      title: "Découvrez le Meilleur Golf de Majorque",
      description: "Votre passerelle vers des parcours de golf premium, des hébergements de luxe et des expériences méditerranéennes inoubliables.",
      bookTeeTime: "Réserver un tee time",
      cta: "Commencez Votre Voyage",
      ctaSecondary: "Voir les parcours à Majorque"
    },
    about: {
      subtitle: "À Propos",
      title: "Votre Concierge Golf Premier à Majorque",
      description: "L'agence de golf leader à Majorque depuis 2003. En tant que seul opérateur exclusif basé sur l'île, nous sommes spécialisés dans tous types de services de golf.",
      point1: "Sélection de parcours championship",
      point2: "Partenariats hôtels & restaurants exclusifs",
      point3: "Service personnalisé dans votre langue"
    },
    courses: {
      subtitle: "Parcours de Golf",
      title: "Des Parcours de Classe Mondiale",
      description: "Réservez des départs sur 19 parcours de golf premium à Majorque, Ibiza & Minorque avec confirmation instantanée.",
      holes: "Trous",
      par: "Par",
      from: "À partir de",
      bookNow: "Réserver un Départ"
    },
    offers: {
      subtitle: "Offres Partenaires",
      title: "Offres Exclusives Pour Vous",
      hotels: "Hôtels de Luxe",
      restaurants: "Gastronomie",
      from: "À partir de",
      save: "Économisez",
      viewDeal: "Voir l'Offre",
      bookHotel: "Réserver",
      exclusive: "Offre Exclusive",
      viewDetails: "Voir les Détails",
      bookNow: "Réserver"
    },
    card: {
      hoverForDetails: "Appuyez pour les détails"
    },
    hotels: {
      subtitle: "Hôtels Partenaires",
      title: "Hébergements de Luxe",
      description: "Séjournez dans les meilleurs hôtels de Majorque avec des forfaits golf exclusifs et des tarifs spéciaux."
    },
    restaurants: {
      subtitle: "Restaurants & Bars",
      title: "Expériences Gastronomiques",
      description: "Découvrez une cuisine méditerranéenne exceptionnelle dans nos restaurants partenaires avec des offres exclusives.",
      reserve: "Réserver une Table"
    },
    beachClubs: {
      subtitle: "Détente Après Le Golf",
      title: "Beach Clubs Premium",
      description: "Détendez-vous après votre partie dans les beach clubs les plus exclusifs de Majorque avec des forfaits spéciaux golfeurs."
    },
    cafeBars: {
      subtitle: "Café, Cocktails & Brunch",
      title: "Bars, Cafés & Brunch",
      description: "De l'espresso matinal parfait aux cocktails au coucher du soleil, découvrez les meilleurs spots de Majorque pour les amateurs de café."
    },
    contact: {
      subtitle: "Contactez-Nous",
      title: "Planifiez Votre Escapade Golf",
      description: "Remplissez le formulaire ci-dessous et notre équipe vous contactera dans les 24 heures pour créer votre expérience golf parfaite à Majorque.",
      name: "Votre Nom",
      email: "Adresse E-mail",
      phone: "Numéro de Téléphone",
      country: "Votre Pays",
      message: "Parlez-nous de vos projets golf",
      send: "Envoyer la Demande",
      success: "Merci! Nous vous contacterons bientôt.",
      countries: {
        germany: "Allemagne",
        sweden: "Suède",
        switzerland: "Suisse",
        uk: "Royaume-Uni",
        france: "France",
        other: "Autre"
      }
    },
    footer: {
      tagline: "L'agence de golf leader à Majorque depuis 2003",
      quickLinks: "Liens Rapides",
      contactInfo: "Infos Contact",
      followUs: "Suivez-Nous",
      rights: "Tous droits réservés."
    },
    blog: {
      subtitle: "Blog Golf",
      title: "Conseils & Perspectives",
      description: "Conseils d'experts, guides de parcours et astuces pour votre expérience golf à Majorque.",
      readMore: "Lire la Suite",
      categories: {
        travelTips: "Conseils Voyage",
        courseGuides: "Guides Parcours",
        lifestyle: "Lifestyle"
      }
    },
    reviews: {
      subtitle: "Avis Clients",
      title: "Ce Que Disent Nos Golfeurs",
      reviewsCount: "avis",
      loadMore: "Charger Plus d'Avis",
      leaveReview: "Partagez Votre Expérience",
      yourRating: "Votre Note",
      yourName: "Votre Nom",
      yourCountry: "Votre Pays",
      coursePlayed: "Parcours Joué (optionnel)",
      reviewTitle: "Titre de l'Avis",
      yourReview: "Parlez-nous de votre expérience...",
      submit: "Soumettre l'Avis",
      submitSuccess: "Merci! Votre avis apparaîtra après approbation.",
      moderationNote: "Les avis sont modérés avant publication.",
      shareExperience: "Joué à Majorque?",
      shareDescription: "Aidez d'autres golfeurs en partageant votre expérience.",
      writeReview: "Écrire un Avis"
    }
  },
  se: {
    nav: {
      home: "Hem",
      courses: "Golfbanor",
      offers: "Partnererbjudanden",
      contact: "Kontakt",
      book: "Boka Nu"
    },
    hero: {
      subtitle: "Exklusiva Golfupplevelser",
      title: "Upptäck Mallorcas Bästa Golf",
      description: "Din port till premiumgolfbanor, lyxboende och oförglömliga Medelhavsupplevelser.",
      bookTeeTime: "Boka tee time nu",
      cta: "Börja Din Resa",
      ctaSecondary: "Se golfbanor på Mallorca"
    },
    about: {
      subtitle: "Om Oss",
      title: "Din Premier Golfconcierge på Mallorca",
      description: "Den ledande golfbyrån på Mallorca sedan 2003. Som den enda exklusiva operatören baserad på ön specialiserar vi oss på alla typer av golftjänster.",
      point1: "Utvalt urval av mästerskapsbanor",
      point2: "Exklusiva hotell- & restaurangpartnerskap",
      point3: "Personlig service på ditt språk"
    },
    courses: {
      subtitle: "Golfbanor",
      title: "Världsklassbanor Väntar",
      description: "Boka tee times på 19 premiumbanaor på Mallorca, Ibiza & Menorca med omedelbar bekräftelse.",
      holes: "Hål",
      par: "Par",
      from: "Från",
      bookNow: "Boka Tee Time"
    },
    offers: {
      subtitle: "Partnererbjudanden",
      title: "Exklusiva Erbjudanden för Dig",
      hotels: "Lyxhotell",
      restaurants: "Fin Dining",
      from: "Från",
      save: "Spara",
      viewDeal: "Se Erbjudande",
      bookHotel: "Boka Nu",
      exclusive: "Exklusivt Erbjudande",
      viewDetails: "Visa Detaljer",
      bookNow: "Boka Nu"
    },
    card: {
      hoverForDetails: "Tryck för detaljer"
    },
    hotels: {
      subtitle: "Hotellpartners",
      title: "Lyxboende",
      description: "Bo på Mallorcas finaste hotell med exklusiva golfpaket och specialpriser för våra kunder."
    },
    restaurants: {
      subtitle: "Restauranger & Barer",
      title: "Kulinariska Upplevelser",
      description: "Upptäck exceptionell medelhavskök på våra partnerrestauranger med exklusiva erbjudanden.",
      reserve: "Reservera Bord"
    },
    beachClubs: {
      subtitle: "Avslappning Efter Golf",
      title: "Premium Beach Clubs",
      description: "Koppla av efter din runda på Mallorcas mest exklusiva strandklubbar med speciella golferpaket."
    },
    cafeBars: {
      subtitle: "Kaffe, Cocktails & Brunch",
      title: "Barer, Kaféer & Brunch",
      description: "Från den perfekta morgonespressot till solnedgångscocktails – upptäck Mallorcas bästa ställen för kaffeälskare."
    },
    contact: {
      subtitle: "Kontakta Oss",
      title: "Planera Din Golfsemester",
      description: "Fyll i formuläret nedan och vårt team kontaktar dig inom 24 timmar för att skapa din perfekta Mallorca-golfupplevelse.",
      name: "Ditt Namn",
      email: "E-postadress",
      phone: "Telefonnummer",
      country: "Ditt Land",
      message: "Berätta om dina golfplaner",
      send: "Skicka Förfrågan",
      success: "Tack! Vi hör av oss snart.",
      countries: {
        germany: "Tyskland",
        sweden: "Sverige",
        switzerland: "Schweiz",
        uk: "Storbritannien",
        france: "Frankrike",
        other: "Annat"
      }
    },
    footer: {
      tagline: "Den ledande golfbyrån på Mallorca sedan 2003",
      quickLinks: "Snabblänkar",
      contactInfo: "Kontaktinfo",
      followUs: "Följ Oss",
      rights: "Alla rättigheter förbehållna."
    },
    blog: {
      subtitle: "Golfblogg",
      title: "Tips & Insikter",
      description: "Expertråd, banguider och insidertips för din Mallorca-golfupplevelse.",
      readMore: "Läs Mer",
      categories: {
        travelTips: "Resetips",
        courseGuides: "Banguider",
        lifestyle: "Livsstil"
      }
    },
    reviews: {
      subtitle: "Kundrecensioner",
      title: "Vad Våra Golfare Säger",
      reviewsCount: "recensioner",
      loadMore: "Ladda Fler Recensioner",
      leaveReview: "Dela Din Upplevelse",
      yourRating: "Din Betyg",
      yourName: "Ditt Namn",
      yourCountry: "Ditt Land",
      coursePlayed: "Spelad Bana (valfritt)",
      reviewTitle: "Recensionstitel",
      yourReview: "Berätta om din upplevelse...",
      submit: "Skicka Recension",
      submitSuccess: "Tack! Din recension visas efter godkännande.",
      moderationNote: "Recensioner modereras innan publicering.",
      shareExperience: "Spelat på Mallorca?",
      shareDescription: "Hjälp andra golfare genom att dela din upplevelse.",
      writeReview: "Skriv en Recension"
    }
  }
};
